export const EN = { value: "en-CA", key: "locale.en-CA" };
export const FR = { value: "fr-CA", key: "locale.fr-CA" };

export default [EN, FR];



// WEBPACK FOOTER //
// ./src/components/common/enums/languages.js